import {
	GROUP_TYPE,
	GROUP_SECTION_WIDTH,
	CURSOR,
	getTextColor,
	drawRectangle,
	drawExpansionIcon,
	getTrimmedText,
	COMMON_IMAGE,
	GROUP_SECTION_MARGIN_LEFT,
	GROUP_SECTION_PADDING_LEFT,
	GROUP_SECTION_SPACING_LEVEL_ONE,
	drawBorder,
	GROUP_SECTION_PROJECT_BORDER_WIDTH,
	GROUP_SECTION_TEXT_GREY_DARK,
	GROUP_SECTION_SPACING_LEVEL_TWO,
	GROUP_SECTION_ACTION_BUTTON_SIZE,
	GROUP_SECTION_BADGE_PADDING_VERTICAL,
	GROUP_SECTION_BADGE_PADDING_HORIZONTAL, GROUP_SECTION_EXPAND_ICON_WIDTH, GROUP_SECTION_EXPAND_ICON_HEIGHT,
} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import Util from '../../../../forecast-app/shared/util/util';
import {hasFeatureFlag} from "../../../../forecast-app/shared/util/FeatureUtil";

class ProjectGroupGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PROJECT_SCHEDULING_PROJECT_GROUP, data);
	}
	draw(canvasContext, x, y) {
		if (hasFeatureFlag("timeline_group_section_restyling")) {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, expanded, groupType, totalHeight} = this;
			super.draw(x, y, width, height, this);
			const {name, id, color, isProjectTimeline, isFirstProjectGroup} = data;
			const cacheId = `${groupType}-${id}-${!!expanded}`;
			const borderThickness = 1;
			const schedulingProjectBorderOffset = isProjectTimeline ? 0 : 1;
			const expandable = !isProjectTimeline || !isFirstProjectGroup;

			if (expandable) {
				interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);
			}

			const drawEncompassingBorder = () => {
				if (!expanded) return;
				drawRectangle(canvasContext, 2, y + height - 1, width - 3, totalHeight - height);
			};

			// draw left connected project border color
			drawBorder(
				canvasContext,
				x + GROUP_SECTION_MARGIN_LEFT - GROUP_SECTION_PROJECT_BORDER_WIDTH,
				y - 1 - (borderThickness * 2) - schedulingProjectBorderOffset,
				height + schedulingProjectBorderOffset,
				true,
				color,
				GROUP_SECTION_PROJECT_BORDER_WIDTH,
			);

			const cachedData = cacheManager.get(groupType, cacheId);
			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				drawEncompassingBorder();
				return;
			}

			const drawGroup = icon => {
				const xOffset = expandable
					? GROUP_SECTION_SPACING_LEVEL_TWO
					: GROUP_SECTION_SPACING_LEVEL_ONE;

				//Subtract 1 from width and height to make room for the grey border
				drawRectangle(
					canvasContext,
					x + GROUP_SECTION_MARGIN_LEFT,
					y,
					width - GROUP_SECTION_SPACING_LEVEL_ONE,
					height
				);

				// top border
				if (isProjectTimeline || (!isProjectTimeline && !isFirstProjectGroup)) {
					const schedulingGroupOffset = !isProjectTimeline && !isFirstProjectGroup ? 1 : 0;
					drawBorder(
						canvasContext,
						x + GROUP_SECTION_MARGIN_LEFT,
						y - schedulingGroupOffset,
						width - GROUP_SECTION_MARGIN_LEFT,
						false,
						'#E7E7F3',
						borderThickness,
					);
				}

				// bottom border
				if (!expanded) {
					drawBorder(
						canvasContext,
						x + GROUP_SECTION_MARGIN_LEFT,
						y - 1 + height,
						width - GROUP_SECTION_MARGIN_LEFT,
						false,
						'#E7E7F3',
						borderThickness,
					);
				}

				// expand icon
				if (expandable) {
					canvasContext.drawImage(
						cacheManager.getCommonImage(expanded ? COMMON_IMAGE.EXPAND_GROUP_ICON : COMMON_IMAGE.EXPAND_GROUP_CLOSED_ICON),
						x + GROUP_SECTION_SPACING_LEVEL_ONE - (GROUP_SECTION_EXPAND_ICON_WIDTH / 2),
						y + (height / 2) - (GROUP_SECTION_EXPAND_ICON_HEIGHT / 2),
						GROUP_SECTION_EXPAND_ICON_WIDTH,
						GROUP_SECTION_EXPAND_ICON_HEIGHT,
					);
				}

				// project id container
				let fontSize = 10;
				canvasContext.font = `600 ${fontSize}px ` + Util.getFontFamily();
				const projectGroupId = `X${data.companyProjectGroupId}`;
				const iconSize = 14;
				const projectIdWidth = canvasContext.measureText(projectGroupId).width;
				const iconProjectIdGap = 10;
				const badgeWidth = projectIdWidth + GROUP_SECTION_BADGE_PADDING_HORIZONTAL + iconSize + iconProjectIdGap;
				const badgeHeight = iconSize + GROUP_SECTION_BADGE_PADDING_VERTICAL;
				const projectIdBorderRadius = 4;
				drawRectangle(
					canvasContext,
					x + xOffset,
					y + (height / 2) - (badgeHeight / 2),
					badgeWidth,
					badgeHeight,
					{
						backgroundColor: color,
						borderThickness: 0,
						borderTopLeftRadius: projectIdBorderRadius,
						borderBottomLeftRadius: projectIdBorderRadius,
						borderTopRightRadius: projectIdBorderRadius,
						borderBottomRightRadius: projectIdBorderRadius,
					}
				);

				// connected project icon
				if (icon) {
					canvasContext.drawImage(
						icon,
						x + xOffset + (GROUP_SECTION_BADGE_PADDING_HORIZONTAL / 2),
						y + (height / 2) - (iconSize / 2),
						iconSize,
						iconSize
					);
				}

				canvasContext.fillStyle = GROUP_SECTION_TEXT_GREY_DARK;

				// project id
				canvasContext.fillText(
					projectGroupId,
					x + xOffset + badgeWidth - (GROUP_SECTION_BADGE_PADDING_HORIZONTAL / 2) - (projectGroupId.length + 10),
					y + (height / 2) + ((((iconSize / 2) + GROUP_SECTION_BADGE_PADDING_VERTICAL) / 2) / 2),
				);

				// project name
				fontSize = 14;
				canvasContext.font = `600 ${fontSize}px ` + Util.getFontFamily();
				const projectSchedulingSpace = !isProjectTimeline ? GROUP_SECTION_ACTION_BUTTON_SIZE : 0;
				const maxNameWidth = GROUP_SECTION_WIDTH() - projectSchedulingSpace - (xOffset + GROUP_SECTION_PADDING_LEFT + badgeWidth) - (GROUP_SECTION_PADDING_LEFT * 2) // adding group section padding for some space
				const formattedProjectName = getTrimmedText(canvasContext, name, maxNameWidth);
				canvasContext.fillText(
					formattedProjectName,
					x + xOffset + GROUP_SECTION_PADDING_LEFT + badgeWidth,
					y + (height / 2) + (fontSize / 3)
				);
			};

			drawGroup(cacheManager.getCommonImage(COMMON_IMAGE.CONNECTED_PROJECT_BLACK));
			drawEncompassingBorder();
		} else {
			const width = GROUP_SECTION_WIDTH();
			const {data, height, expanded, groupType, totalHeight} = this;
			super.draw(x, y, width, height, this);
			const {name, id, color} = data;
			const cacheId = `${groupType}-${id}-${!!expanded}`;

			interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

			const drawEncompassingBorder = () => {
				if (!expanded) return;
				drawRectangle(canvasContext, 2, y + height - 1, width - 3, totalHeight - height, {
					backgroundColor: color,
					borderBottomLeftRadius: 10,
				});
			};

			const cachedData = cacheManager.get(groupType, cacheId);
			if (cachedData) {
				canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
				drawEncompassingBorder();
				return;
			}

			const planning = false; // data.status === PROJECT_STATUS.PLANNING;
			//TODO can project group be in planning stage? Is it if all projects are in plannig or any or never???
			const textColor = planning ? '#2a2a2a' : getTextColor(color);

			const drawGroup = icon => {
				//Subtract 1 from width and height to make room for the grey border
				drawRectangle(canvasContext, x + 2, y + 0, width - 3, height - (expanded ? 0 : 1), {
					backgroundColor: color,
					backgroundOpacity: planning ? 0.3 : 1,
					borderColor: color,
					borderThickness: planning ? 2 : 0,
					borderTopLeftRadius: 10,
					borderBottomLeftRadius: expanded ? 0 : 10,
				});
				drawExpansionIcon(canvasContext, x, y, width, height, {
					backgroundColor: planning ? undefined : color,
					expanded,
				});
				canvasContext.fillStyle = textColor;
				canvasContext.font = '700 10px ' + Util.getFontFamily();
				canvasContext.fillText(`X${data.companyProjectGroupId}`, x + 16, y + 24);
				canvasContext.font = '500 12px ' + Util.getFontFamily();
				const formattedProjectName = getTrimmedText(canvasContext, name);
				canvasContext.fillText(formattedProjectName, x + 70, y + 25);
				if (icon) {
					canvasContext.drawImage(icon, x + 52, y + 13, 14, 14);
				}
			};
			drawGroup(cacheManager.getCommonImage(COMMON_IMAGE[textColor === '#ffffff' ? 'CONNECTED_PROJECT_WHITE' : 'CONNECTED_PROJECT_BLACK']));
			drawEncompassingBorder();
		}
	}
}
export default ProjectGroupGroup;
